import React, { Component } from 'react'
import Inputs from '../../shared/FormComponents/Inputs'
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import './ForgotPassword.css'

export default class ForgotPasswordConfirm extends Component {
  static propTypes = {};
  constructor(props) {
    super(props);
    this.state = {
      uppercase: false,
      lowercase: false,
      numberic: false,
      specialCharacter: false,
      passwordFormValid: false,
      passwordChangeServerStatus: false,
      forgotPasswordData:{
        password: '',
        confPassword: '',
      },
      inputStates: {
        password: false,
        confPassword: false,

      }
    };
  }


  onChangePassword = (key, value, valid) => {
    let state = _.extend({}, this.state);
    state.forgotPasswordData[key] = value;
    state.inputStates[key] = valid;
    this.setState(state, () => this.validatePasswordForm());
    if( key === 'password' ){
      let incLower = this.lowercase(value)
      let incuppercase = this.uppercase(value)
      let incnumberic = this.numberic(value)
      let specialCharacter = this.specialCharacter(value);

      if (incLower) {
          this.setState({  uppercase : true });
      }else{
          this.setState({  uppercase : false });
      }
      if (incuppercase){
          this.setState({  lowercase : true });
      }else{
          this.setState({  lowercase : false });
      }
      if(incnumberic){
          this.setState({  numberic : true });
      }else{
          this.setState({  numberic : false });
      }
      if(specialCharacter){
          this.setState({  specialCharacter : true });
      }else{
          this.setState({  specialCharacter : false });
      }
    }
  };

  validatePasswordForm = () => {
    const validationStates = _.extend({}, this.state.inputStates);
    const { password, confPassword } = this.state.forgotPasswordData;
    const checkFields = password.trim() && confPassword.trim() ? true : false;
    const key = Object.values(validationStates).indexOf(false) !== -1;
    const state = !key;
    this.setState({ passwordFormValid: state && checkFields });
  };

  onDataChange = (key, value, valid) => {
    const state = _.extend({}, this.state);
    state.inputStates[key] = valid;
    state.forgotPasswordData[key] = value;
    this.setState(state, () => this.validateForm());
  };

  lowercase = (str) => {
    return str.match(/[a-z]/);
  }

  uppercase = (str) => {
      return str.match(/\w*[A-Z]\w*/);
  }

  numberic = (str) => {
      return str.match(/\d+/)
  }

  specialCharacter = (str) => {
      return str.match(/[$@#$!%*?&]/);
  }

  validateForm = () => {
    let validationStates = _.extend({}, this.state.inputStates);
    let key = Object.values(validationStates).indexOf(false) !== -1;
    let state = !key;

    const { password, confPassword } = this.state.data;
    const checkFields = password.trim() && confPassword.trim() ? true : false;
    this.setState({ formValid: state && checkFields });
  }

  onForgotPasswordConfirm = () => {
    const body = {
        email: this.props.locationEmail,
        code: this.props.locationCode,
        newPassword: this.state.forgotPasswordData.password
    };
    if (body.email && body.code) {
      this.props.onForgotPasswordConfirm(body);
    }

  }

  render() {
    const passwordConfirm = this.state.forgotPasswordData.password === this.state.forgotPasswordData.confPassword ? true : false;

    return (
        <div className="forgot-password-content">
            <div className="forgot-password-content-layout">

                <div className="card">
                    <div className='card-header'>
                        <div className="logo-bg-layout">
                            <div className='login-logo-box'></div>
                        </div>
                    </div>
                    <div className="card-body">
                        <form>
                            <div className="form-group icon-input">
                                <i class="fas fa-unlock-alt"></i>
                                <Inputs
                                    type="password"
                                    className="form-control"
                                    value={this.state.forgotPasswordData.password}
                                    required={ true }
                                    onChange={ (value, valid) => this.onChangePassword('password', value, valid)}
                                    placeholder='Password'
                                    // onChange={ (value, valid) => this.onDataChange('loginPassword', value, valid)}
                                />
                                <ul className="password-valid-card">
                                  <li className={ this.state.lowercase ? 'done' : '' } > <i class="fas fa-circle"></i> Minimum of one lowercase character</li>
                                  <li className={ this.state.uppercase ? 'done' : '' } > <i class="fas fa-circle"></i> Minimum of one uppercase character</li>

                                  <li className={ this.state.numberic ? 'done' : '' }> <i class="fas fa-circle"></i> Minimum of one numeric character</li>

                                  <li className={ this.state.specialCharacter ? 'done' : '' }> <i class="fas fa-circle"></i> Minimum of one special character</li>
                                </ul>
                            </div>
                            <div className='form-group icon-input'>
                                <i class="fas fa-unlock-alt"></i>
                                <Inputs
                                    type="confirm_password"
                                    className="form-control"
                                    placeholder='Confirm Password'
                                    value={this.state.forgotPasswordData.confPassword}
                                    password={this.state.forgotPasswordData.password}
                                    required={ true }
                                    onChange={ (value, valid) => this.onChangePassword('confPassword', value, valid)}
                                    errorMessage={'5555'} />
                            </div>
                            <button
                                type="button"
                                onClick={this.onForgotPasswordConfirm}
                                disabled={!this.state.passwordFormValid || !passwordConfirm}
                                className="btn forgot-password-button">
                                Send
                                {this.props.forgotPasswordPending && <i className="fa fa-spinner fa-spin fa-3x fa-fw"></i>}
                            </button>
                            <div className="btn empty-btn default"><Link to='/login'>Back</Link></div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ForgotPassword/ForgotPasswordConfirm.jsx